import { Inject, Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class FeatureAccessService {
  featuresList: any[] = [];
  constructor() {
  }

  getAccessPermission(url: any): boolean | undefined {
    var list = localStorage.getItem("currentFeatures");
    if (list) {
      const featureList = JSON.parse(list);

      if (featureList.find((x: any) => x.apiUrl == '/ai') == undefined) {
        featureList.push(
          {
            "id": "31039893-0e31-4118-aad7-68cc9a1445a4",
            "name": "AI Hub",
            "description": "AI Hub",
            "apiUrl": "/ai",
            "isActive": true,
          })
      }


      this.featuresList.push(featureList);
      var result = featureList.find((x: any) => x.apiUrl.toLowerCase() == url.toLowerCase());
      if (result) {
        return true;
      } else {
        return false;
      }
    } else {

      /*return undefined;*/

      //TODo : - Implement later

      return true;


    }
  }
}
